import React from "react";


export default ({label, placeholder, type, value, onChange, errorMessage, successMessage}) => {


    const labelClasses =
        successMessage ? "text-green-700 dark:text-green-500" :
        errorMessage ? "text-red-700 dark:text-red-500": ""

    const inputClasses =
        successMessage ? "bg-green-50 border-green-500 text-green-900 dark:text-green-400 placeholder-green-700 dark:placeholder-green-500 focus:ring-green-500 focus:border-green-500 dark:border-green-500":
        errorMessage ?   "bg-red-50 border-red-500 text-red-900 placeholder-red-700 text-sm rounded-lg focus:ring-red-500 dark:bg-gray-700 focus:border-red-500 dark:text-red-500 dark:placeholder-red-500 dark:border-red-500":
            ""

    return <>
        <div className="mb-6">
            <label
                className={`block mb-2 text-sm font-medium ${labelClasses}`}
            >
                {label}
            </label>
            <input
                type={type}
                className={`border text-sm rounded-lg block w-full p-2.5 dark:bg-gray-700 ${inputClasses}`}
                placeholder={placeholder}
                onChange={onChange}
                value={value}
            />
            {successMessage && <div className="mt-2 text-sm text-green-600 dark:text-green-500"><span
                className="font-medium"></span> {successMessage}
            </div>
            }
            {errorMessage &&
                <div className="mt-2 text-sm text-red-600 dark:text-red-500">
                    <span className="font-medium"></span>{errorMessage}
                </div>
            }
        </div>
    </>
}
